import { render } from "./CommentView.vue?vue&type=template&id=0a67fdb3"
import script from "./CommentView.vue?vue&type=script&lang=js"
export * from "./CommentView.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__